import { useMemo } from 'react';

import { processTableFilterOptions } from '../../utils/table-helpers';
import { splitCommaList } from './utils';

type FilterOption = { text: mixed, value: string };

export type DataFilterOptions = {
  affordableProgram: Array<FilterOption>,
  preferredUnitSize: Array<FilterOption>,
  incomeLevel: Array<FilterOption>,
};

type Position = {
  affordableWaitlist: {
    affordableProgram?: ?string,
    incomeLevel?: ?string,
    application: { preferredUnitSize?: ?string },
  },
};

/**
 * Filter options for the columns whose values come from the data rather than a
 * fixed list. Built from the unfiltered positions so an option does not vanish
 * once a filter excludes the rows that carry it.
 */
const useFilterOptions = ({
  positions,
}: {
  positions: Array<Position>,
}): DataFilterOptions =>
  useMemo(() => {
    const values = {
      affordableProgram: [],
      preferredUnitSize: [],
      incomeLevel: [],
    };

    positions.forEach(({ affordableWaitlist }) => {
      const { affordableProgram, incomeLevel, application } =
        affordableWaitlist;
      values.affordableProgram.push(...splitCommaList(affordableProgram));
      values.preferredUnitSize.push(
        ...splitCommaList(application.preferredUnitSize),
      );
      if (incomeLevel) values.incomeLevel.push(incomeLevel);
    });

    // Dedupes, sorts and maps each list to { text, value } in place.
    processTableFilterOptions(values);

    return values;
  }, [positions]);

export default useFilterOptions;
